import { FormBuilder } from '@angular/forms';
import { PlannerDTOField } from '../interfaces/PlannerDTOField';
import { PlannerBaseDTO } from './PlannerBaseDTO';
import { SocialPlanDTO } from './SocialPlanDTO';
import { LinearPlanDTO } from './LinearPlanDTO';
import { DigitalPlanDTO } from './DigitalPlanDTO';

export class ChannelPlanDTO extends PlannerBaseDTO {
    fields: PlannerDTOField[] = [
        {
            name: 'digital',
            type: 'formGroup',
            arrayClass: DigitalPlanDTO,
            createInitialItem: true
        },
        {
            name: 'linear',
            type: 'formGroup',
            arrayClass: LinearPlanDTO,
            createInitialItem: false
        },
        {
            name: 'social',
            type: 'formGroup',
            arrayClass: SocialPlanDTO,
            createInitialItem: false
        },
    ];

    constructor(fb: FormBuilder) {
        super(fb);
        this.init();
    }
}
